import { Component } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { LacertaFormSubmitStatus } from '@lacerta/form';
import { JazzmoMailchimpApiService } from '../../core/jazzmo-wagtail/mailchimp/mailchimp-api.service';

@UntilDestroy()
@Component({
  selector: 'jazzmo-newsletter',
  templateUrl: './newsletter.component.html',
  styleUrls: ['./newsletter.component.scss'],
})
export class NewsletterComponent {
  subscriptionStatus = LacertaFormSubmitStatus.NOT_SUBMITTED;

  constructor(private jazzmoMailchimpApiService: JazzmoMailchimpApiService) {}

  handleSubscribe(emailAddress: string) {
    this.subscriptionStatus = LacertaFormSubmitStatus.SUBMITTED_VALID;
    this.jazzmoMailchimpApiService.post(emailAddress).subscribe(
      () => {
        this.subscriptionStatus = LacertaFormSubmitStatus.SUBMIT_SUCCESS;
      },
      () => {
        this.subscriptionStatus = LacertaFormSubmitStatus.SUBMIT_ERROR;
      }
    );
  }

  get subscriptionDisabled() {
    return (
      this.subscriptionStatus &&
      [LacertaFormSubmitStatus.NOT_SUBMITTED, LacertaFormSubmitStatus.SUBMITTED_VALID, LacertaFormSubmitStatus.SUBMIT_SUCCESS].includes(
        this.subscriptionStatus
      )
    );
  }

  get submitError() {
    return this.subscriptionStatus === LacertaFormSubmitStatus.SUBMIT_ERROR;
  }

  get subscribed() {
    return this.subscriptionStatus === LacertaFormSubmitStatus.SUBMIT_SUCCESS;
  }
}
